//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionEdit(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.92 5L20.43 8.52L21.85 7.1L16.92 2.17L3 16.09V21H7.91L19.02 9.9L17.6 8.48L7.09 19H5V16.91L16.92 5Z" fill="currentColor" /></svg>;
}
export default IconActionEdit;